module.exports = __webpack_public_path__ + "static/media/doughnut.a9536efb.png";